import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=e7736256&scoped=true&lang=pug&"
import script from "./Step4.vue?vue&type=script&lang=ts&"
export * from "./Step4.vue?vue&type=script&lang=ts&"
import style0 from "./Step4.vue?vue&type=style&index=0&id=e7736256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7736256",
  null
  
)

export default component.exports